import { useMutation } from "@tanstack/react-query";
import { updateFaqGroupStatus } from "../api/updateFaqGroupStatus";
import { invalidateFaqGroupsQuery } from "../queries/useFaqGroupsQuery";
import { UpdateStatusParams } from "../types";

export const useUpdateFaqGroupStatusMutation = () => {
  return useMutation({
    mutationFn: async ({ faqGroupId, status }: UpdateStatusParams) => {
      return await updateFaqGroupStatus(faqGroupId, status);
    },
    onSuccess: () => {
      invalidateFaqGroupsQuery();
    },
    onError: (e) => {
      console.error("Error occurred when updating faq group", e);
    },
  });
};
